import { render, staticRenderFns } from "./boardSorter.vue?vue&type=template&id=2f253713&scoped=true"
import script from "./boardSorter.vue?vue&type=script&lang=js"
export * from "./boardSorter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f253713",
  null
  
)

export default component.exports